// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5f5a9dc6","247":"bcee86f8","284":"b4d625a8","422":"e224af18","627":"5a3cd33f","834":"7e4c094c","867":"d2713f93","923":"2afbb64f","938":"7593c036"}[chunkId] + ".chunk.js";
};